import React, { useRef, useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import * as TokenActions from './actions';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames';
import SelectedActions from '../selected-actions/SelectedActions';
import { List, WindowScroller, AutoSizer } from 'react-virtualized'
import Token from './Token';
import Checkbox from '../components/Checkbox';
import Tooltip from '../components/Tooltip'

const TokensList = ({
  dispatch,
  accounts,
  transactions,
  transactionStack,
  style,
  jabraTokens
}) => {
  const listRef = useRef(null);

  const propTypes = {
    className: PropTypes.string,
    jabraTokens: PropTypes.array.isRequired,
  }

  const defaultProps = {
    className: ''
  }

  const [ selected, setSelected ] = useState([]);
  const [ focused, setFocused ] = useState(null);
  const [ firstVisibleRow, setFirstVisibleRow ] = useState(null);
  const [ isDragging, setIsDragging ] = useState(false);

  const filesRefs = {}

  const selectedTokens = () => {
    return selected.map(name =>
      jabraTokens.find(el => el.tokenId === name)
    ).filter(n => n)
  }

  const focusedFile = () => {
    return jabraTokens.find(el => el.tokenId === focused)
  }

  const selectedMenu = () => {
    if (selected.length === 0)
      return null

    const unselectAll = () => toggleAll(false);
    const innerWidthEm = window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);

    return (
      <SelectedActions
        className={'fixed bottom-0 right-0'}
        style={{
          maxWidth: innerWidthEm < 60 ? '100%' : 'calc(100% - 156px)',
          zIndex: 20
        }}
        unselect={unselectAll}
        send={() => onSend(selectedTokens()[0].tokenId)}
        cancel={() => onCancel(selectedTokens())}
        count={selected.length}
        animateOnStart />
    )
  }

  const onSend = tokenId => {
    dispatch(fetchTokenId(tokenId));
  }

  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;
  const [ stackId, setStackId ] = useState(null);
  const [ stackLen, setStackLen ] = useState(0);
  const [ confirmedQueue, setConfirmedQueue ] = useState([]);
  const [ confirmedReserve, setConfirmedReserve ] = useState({ stackId: null, confirmedStart: null, confirmedEnd: null });

  const onCancel = async _jabraTokens => {
    const jabraNumberShift = 8;
    var jabraNumber = null;
    var startTime = null;
    var endTime = null;

    var estimatedGas = null;
    var estimatedGasPrice = null;
    var stackId = null;

    const multiplicationFactor = 1.3;
    const gasPriceMultiplication = 2.4;
    var nonceConst = await drizzle.web3.eth.getTransactionCount(accounts[0]);
    var nonce = null;

    for (var i = 0; i < _jabraTokens.length; i++) {
      jabraNumber = _jabraTokens[i].tokenId % (2 ** jabraNumberShift);
      startTime = _jabraTokens[i].startTime;
      endTime = _jabraTokens[i].endTime;

      estimatedGas = await contract.methods.cancelTokensForPeriod(
          jabraNumber, startTime
        ).estimateGas({
          from: accounts[0]
      });

      estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
      nonce = nonceConst + i;

      stackId = await contract.methods["cancelTokensForPeriod"].cacheSend(jabraNumber, startTime, {
        from: accounts[0],
        gas: Math.floor(estimatedGas*multiplicationFactor),
        gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
        nonce
      });
      setConfirmedReserve({
        type: 'cancel',
        stackId: stackId,
        _jabraNumber: jabraNumber+1,
        confirmedStart: startTime*1000,
        confirmedEnd: endTime*1000
      })
      setStackId(stackId);
    }
    dispatch(notifyMultipleCancel());
  }

  useEffect(() => {
    const length = transactionStack.length;
    if (length === stackLen)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'pending' && transactions[txHash].confirmations.length === 0) {
      setStackLen(length);
      setConfirmedQueue([...confirmedQueue, confirmedReserve]);
    }
  }, [transactions]);

  useEffect(() => {
    let newConfirmedQueue = confirmedQueue;

    for (let i = 0; i < confirmedQueue.length; i++) {
      if (transactions[transactionStack[confirmedQueue[i].stackId]].status === 'success') {
        newConfirmedQueue = newConfirmedQueue.filter(elm => elm.stackId !== confirmedQueue[i].stackId);
        setConfirmedQueue([...newConfirmedQueue]);
      }
    }
  }, [transactions]);

  useEffect(() => {
    dispatch(notifyManipulateReserveAtSearchPage(confirmedQueue));
  }, [confirmedQueue]);

  useEffect(() => {
    document.addEventListener('keyup', keyHandler)

    return () => {
      document.removeEventListener('keyup', keyHandler)
    }
  }, []);

  useEffect(() => {
    const _selected = selected.filter(name => (
      jabraTokens.find(el => el.tokenId === name)
    ))

    if (_selected.length !== selected.length)
      setSelected(_selected)
  });

  const keyHandler = (e) => {
    if (e.key === 'Escape') {
      setSelected([]);
      setFocused(null);
      return listRef.current.forceUpdateGrid()
    }

    if (e.key === ' ' && focused !== null) {
      e.preventDefault()
      return toggleOne(focused, true)
    }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      let index = 0

      if (focused !== null) {
        const prev = jabraTokens.findIndex(el => el.tokenId === focused)
        index = (e.key === 'ArrowDown') ? prev + 1 : prev - 1
      }

      if (index === -1) {
        return
      }

      if (index < jabraTokens.length) {
        let tokenId = jabraTokens[index].tokenId

        // If the file we are going to focus is out of view (removed
        // from the DOM by react-virtualized), focus the first visible file
        if (!filesRefs[tokenId]) {
          tokenId = jabraTokens[firstVisibleRow].tokenId;
        }

        setFocused(tokenId);
        const domNode = findDOMNode(filesRefs[tokenId])
        domNode.scrollIntoView({ behaviour: 'smooth', block: 'center' })
        domNode.querySelector('input[type="checkbox"]').focus()
      }

      listRef.current.forceUpdateGrid()
    }
  }

  const toggleAll = (checked) => {
    let selected = []

    if (checked) {
      selected = jabraTokens.map(token => token.tokenId)
    }

    setSelected(selected)
    listRef.current.forceUpdateGrid()
  }

  const toggleOne = (tokenId, check) => {
    const index = selected.indexOf(tokenId)

    if (check && index < 0) {
      selected.push(tokenId)
    } else if (index >= 0) {
      selected.splice(selected.indexOf(tokenId), 1)
    }

    setSelected([...selected.sort()])
    listRef.current.forceUpdateGrid()
  }

  const emptyRowsRenderer = () => {
    return (
      <div className='pv3 b--light-gray bt tc gray f6'>
        There are no available tokens.
      </div>
    )
  }

  const rowRenderer = ({ index, key, style }) => {
    return (
      <div key={key} style={style} ref={r => { filesRefs[jabraTokens[index].tokenId] = r }}>
        <Token
          {...jabraTokens[index]}
          onSelect={toggleOne}
          focused={focused === jabraTokens[index].tokenId}
          selected={selected.indexOf(jabraTokens[index].tokenId) !== -1}
        />
      </div>
    )
  }

  const onRowsRendered = ({ startIndex }) => setFirstVisibleRow(startIndex);

  const allSelected = selected.length !== 0 && selected.length === jabraTokens.length
  const rowCount = jabraTokens.length
  const checkBoxCls = classnames({
      'o-1': allSelected,
      'o-70': !allSelected
     }, ['ml4 pl2 w2 glow'])

  // FIXME I'll implement sorting function.
  return (
    <section ref={(el) => { const root = el }} className='relative' style={style}>
      <Fragment>
        <div className='gray pv3 flex items-center' style={{ paddingRight: '1px', paddingLeft: '1px', background: 'white' }}>
          <div className={checkBoxCls}>
            <Checkbox checked={allSelected} onChange={toggleAll} aria-label={'selectAllEntries'}/>
          </div>
          <div className='flex flex-column f6' style={{ width: '10.5rem' }}>
            <button aria-label={ ('sortBy', 'terms.jabraNumber') } >
              <Tooltip text='Token ID'>
                <div className='f6 truncate charcoal'>Token ID</div>
              </Tooltip>
            </button>
            <button aria-label={ ('sortBy', 'terms.jabraNumber') } >
              <Tooltip text='Token ID'>
                <div className='f6 truncate'>Jabra Number</div>
              </Tooltip>
            </button>
            <div style={{ width: '8.3rem' }} />
          </div>
          <div className='f6' style={{ width: '10.5rem', display: 'flex', flexDirection: 'column' }}>
            <button aria-label={ ('sortBy', 'terms.jabraNumber') } style={{ display: 'inline-block' }}>
              <Tooltip text='Start Time' style={{ display: 'inline-block' }}>
                <div className='f6 truncate'>Start Time</div>
              </Tooltip>
            </button>
            <button aria-label={ ('sortBy', 'terms.jabraNumber') } >
              <Tooltip text='End Time'>
                <div className='f6 truncate'>End Time</div>
              </Tooltip>
            </button>
            <div style={{ width: '8.3rem' }} />
          </div>
          <div className='pr4 f6 flex-none db-l dn' style={{ margin: '0 0 0 auto' }}>
            <button aria-label={ ('sortBy', 'terms.reservedTime') }>
              Reserved Time
            </button>
          </div>
          <div style={{ width: '6.0rem' }} />
        </div>
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <div className='flex-auto' style={{ background: 'white' }}>
              <AutoSizer disableHeight>
                {({ width }) => (
                  <List
                    ref={listRef}
                    autoHeight
                    width={width}
                    height={height}
                    className='outline-0'
                    aria-label={'tokensListLabel'}
                    rowCount={rowCount}
                    rowHeight={74}
                    rowRenderer={rowRenderer}
                    noRowsRenderer={emptyRowsRenderer}
                    onRowsRendered={onRowsRendered}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    data={jabraTokens /* NOTE: this is a placebo prop to force the list to re-render */} />
                )}
              </AutoSizer>
            </div>
          )}
        </WindowScroller>
        {selectedMenu()}
      </Fragment>
    </section>
  )
}

const fetchTokenId = (tokenId, startTime) => {
  return {
    type: TokenActions.TOKENID_FETCHING,
    tokenId: tokenId
  }
}

const notifyManipulateReserveAtSearchPage = confirmedQueue => {
  return {
    type: TokenActions.RESERVE_CONFIRMED_AT_SEARCHPAGE,
    confirmedQueueFromSearchPage: confirmedQueue
  }
}

const notifyMultipleCancel = () => {
  return {
    type: TokenActions.TOKEN_MULTIPLE_CANCEL
  }
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack,
    tokenId: state.token.tokenId
  };
};

export default connect(mapStateToProps)(TokensList);
